import React, { useState } from "react";
import { motion } from "framer-motion";
import { CalendarDays, MapPin, ArrowUpRight, PhoneCall } from "lucide-react";
import { useSelector } from "react-redux";

import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";

import { fadeUp } from "../../animations/variants";
import { networkingEvents } from "i18n/Events";
import CTAButton from "Util/CTAButton";
import { useNavigate } from "react-router-dom";
import EventCard from "./Eventcard";

const AllEvents = () => {
  const lang = useSelector((state) => state.language.lang);

  const t = networkingEvents[lang];

  const [tab, setTab] = useState("upcoming");
  const navigate = useNavigate();

  const isUpcoming = (event) => {
    return new Date(event.eventDate) >= new Date();
  };

  const isPast = (event) => {
    return new Date(event.eventDate) < new Date();
  };

  const upcomingEvents = t.events
    .filter(isUpcoming)
    .sort((a, b) => new Date(a.eventDate) - new Date(b.eventDate));

  const pastEvents = t.events
    .filter(isPast)
    .sort((a, b) => new Date(b.eventDate) - new Date(a.eventDate));

  const filteredEvents = tab === "upcoming" ? upcomingEvents : pastEvents;
  return (
    <section className="relative overflow-hidden py-24 lg:py-32 bg-[#0d0d0d]">
      {/* background */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -top-40 right-0 w-[450px] h-[450px] rounded-full bg-reddark/10 blur-[140px]" />
        <div className="absolute bottom-0 left-0 w-[350px] h-[350px] rounded-full bg-red-500/10 blur-[120px]" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 md:px-6">
        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          className="rounded-[36px] border border-white/10 bg-white/[0.03] backdrop-blur-xl overflow-hidden"
        >
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-reddark via-red-500 to-reddark" />
          <div className="p-3 lg:p-6">
            {/* Heading */}
            <motion.div variants={fadeUp} className="text-center mb-12">
              {/* <div className="flex justify-center items-center gap-4 mb-5">
                <span className="w-6 h-px bg-reddark" />
                <span className="uppercase tracking-[0.25em] text-xs text-white/70">
                  {t.hero.badge}{" "}
                </span>
                <span className="w-6 h-px bg-reddark" />
              </div> */}

              <h2 className="font-[Crimson] text-4xl lg:text-5xl text-white">
                {t.hero.title}
              </h2>
            </motion.div>

            {/* Tabs */}
            <div className="flex justify-start mb-12">
              <div className="flex gap-8 border-b border-white/10">
                {[
                  { key: "upcoming", label: t.tabs.upcoming },
                  { key: "past", label: t.tabs.past },
                ].map((item) => (
                  <button
                    key={item.key}
                    onClick={() => setTab(item.key)}
                    className={`pb-3 transition font-medium ${
                      tab === item.key
                        ? "text-white border-b-2 border-reddark"
                        : "text-white/50 hover:text-white"
                    }`}
                  >
                    {item.label}
                  </button>
                ))}
                {/* {[t.tabs.upcoming, t.tabs.past].map((item) => (
                  <button
                    key={item}
                    onClick={() => setTab(item)}
                    className={`pb-3 transition font-medium ${
                      tab === item
                        ? "text-white border-b-2 border-reddark"
                        : "text-white/50 hover:text-white"
                    }`}
                  >
                    {item}
                  </button>
                ))} */}
              </div>
            </div>

            {/* EVENTS */}
            {tab !== t.tabs.media && (
              <div className="hidden md:grid md:grid-cols-2 xl:grid-cols-4 gap-6">
                {filteredEvents.map((event) => (
                  <EventCard key={event.id} event={event} />
                ))}
              </div>
            )}

            <div className="md:hidden">
              <Swiper
                modules={[Pagination, Autoplay]}
                slidesPerView={1}
                centeredSlides={false}
                spaceBetween={18}
                loop={true}
                autoplay={{
                  delay: 4000,
                  disableOnInteraction: false,
                }}
                // pagination={{
                //   clickable: true,
                // }}
                breakpoints={{
                  0: {
                    slidesPerView: 1,
                  },

                  768: {
                    slidesPerView: 2,
                  },

                  1200: {
                    slidesPerView: 3,
                  },
                }}
              >
                {filteredEvents.map((event) => (
                  <SwiperSlide key={event.id}>
                    <EventCard event={event} />
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>{" "}
        </motion.div>{" "}
      </div>
    </section>
  );
};

export default AllEvents;
